<template lang='pug'>
v-main
  v-container(fluid)
    div(style="display: flex;justify-content: space-between;padding: 1rem;background: white;padding-bottom: .2rem;")
      p(style="font-size: 1.25rem;line-height: 1.5;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;") Create New IM Announcement
      v-btn(v-if="$route.name !== 'Forex Request' && $route.name !== 'Document Legal F1' && $route.name !== 'Document Legal F2'" color='blue-secondary' to='/my-request') LIST MEMO

    v-stepper(v-model="e1")
      v-stepper-header
        v-stepper-step(:complete="e1 > 1" step="1")
          | Subject
        v-divider
        v-stepper-step(:complete="e1 > 2" step="2")
          | Details
        v-divider
        v-stepper-step(:complete="e1 > 2" step="2")
          | Approver
      v-stepper-items
        v-stepper-content(step="1")
          v-card.mb-2(style="box-shadow: none")
            //- | HALAMAN `1`
            v-card(flat)
              v-card-text.p-5
                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    v-subheader(color="black")
                      | &nbsp;Business Unit&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-autocomplete(
                      style="padding: 0",
                      id="imSelectBU",
                      label="Select Business Unit",
                      :items="myBuList",
                      item-text="label",
                      item-value="value",
                      v-model="imAnchSelectedBU",
                      placeholder="Select",
                      required
                      @change="trigerChange"
                    )

                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;Subject&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-text-field(
                      id="imSubject",
                      style="padding: 0",
                      label="Subject",
                      v-model="imAnchSubject"
                    )
                
                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;From&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-text-field(
                      id="imFrom",
                      style="padding: 0",
                      label="From",
                      v-model="imAnchFrom"
                    )
                
                v-row(no-gutters)
                  v-col(cols="3") 
                    |
                    |
                    v-subheader(color="black")
                      | &nbsp;To&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-text-field(
                      id="imTo",
                      style="padding: 0",
                      label="To",
                      v-model="imAnchTo"
                    )

          v-btn(id="imPage1Cancel", style="background-color: #f5f5f5;" depressed, large, text="" @click="$router.push('/my-request')") Cancel
          v-btn(id="imPage1Next", depressed, large, style="margin: 0.5rem" :disabled="form1Validation" color="primary", @click="e1 = 2") Next
        v-stepper-content(step="2")
          v-card.mb-2(style="box-shadow: none")
            //- | HALAMAN `1`
            v-card(flat)
              p(v-if="vNullAncDtl" style='color:red') Announcement Details is Required
              <textarea id="editor4" name="editor4"></textarea>
          v-btn(id="imPage2Cancel", style="background-color: #f5f5f5;margin: 0.3rem" depressed, large, text="" @click="$router.push('/my-request')") Cancel
          v-btn(id="imPage2Back", depressed, large, style="margin: 0.3rem" dark, color="blue-grey", @click="e1 = 1") Back
          v-btn(id="imPage2Next", depressed, large, style="margin: 0.3rem" color="primary", @click=" getMyBUMember();") Next
        v-stepper-content(step="3" style="padding:0")
          v-alert(
            style="margin:0"
            dismissible,
            color="red",
            dark,
            v-model="alert",
            transition="scale-transition"
          ) {{ alertMessage }}
          v-card(style="box-shadow: none; padding:1rem 1rem; border-top: 1px solid #adadad;")
            div(style="display: flex;width: 100%;justify-content: space-between;")
              div(style="padding:0 1rem; flex:1")
                v-autocomplete(
                  style="padding: 0; margin:.5",
                  label="Approver",
                  id="imInternalApprover",
                  :items="myBuMember",
                  v-model="approver",
                  placeholder="Select",
                  chips,
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data",
                  return-object,
                  multiple,
                  :append-icon="'close'"
                  @click:append="handleClearEvent(1)"
                  :readonly="max_total_approver !== 0 ? approver.length >= max_total_approver : false"
                )
                  template(v-slot:selection="data")
                    v-chip(
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="removeApp(data.item)"
                    ) {{ data.item.alias }}
                  template(v-slot:item="data")
                    template(v-if="typeof data !== 'object'")
                      v-list-tile-content(v-text="data.item")
                    template(v-else)
                      v-list-tile-content
                        v-list-tile-title.mr-1 {{ data.item.alias }} - {{ data.item.position }} ({{ data.item.business_unit.bu_name }})
                        p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}

                v-autocomplete(
                  :search-input.sync='searchCrossBU' 
                  style="padding: 0; margin:.5",
                  label="Approver Cross BU",
                  id="imCrossApprover",
                  v-model="approver",
                  chips
                  color="blue-grey lighten-2"
                  :items="crosBuMember",
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data"
                  multiple
                  :append-icon="'close'"
                  @click:append="handleClearEvent(2)"
                  hide-no-data='' 
                  hint="Enter at least 3 letters to find out the search results."
                  return-object=true
                  :readonly="max_total_approver !== 0 ? approver.length >= max_total_approver : false"
                )
                  template(v-slot:selection="data")
                    v-chip.chip--select-multi(
                      :selected="data.selected",
                      close,
                      @click:close="removeApp(data.item)"
                    ) {{ data.item.alias }}
                  template(v-slot:item="data")
                    template(v-if="typeof data !== 'object'")
                      v-list-tile-content(v-text="data.item")
                    template(v-else)
                      v-list-tile-content
                        v-list-tile-title.mr-1 {{ data.item.alias }} - {{ data.item.position }} ({{ data.item.business_unit.bu_name }})
                        p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}

                v-autocomplete(
                  style="padding: 0; margin:.5",
                  label="CC",
                  id="imInternalCC",
                  v-model="tembusan",
                  :items="getCCData",
                  chips,
                  color="blue-grey lighten-2",
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data",
                  return-object,
                  multiple,
                  :append-icon="'close'"
                  @click:append="handleClearEvent(3)"
                  @change="removeCc()"
                  hide-details
                )
                  template(v-slot:selection="data")
                    v-chip.chip--select-multi(
                      :selected="data.selected",
                      close,
                      @click:close="removeCc(data.item)"
                    ) {{ data.item.alias }}
                  template(v-slot:item="data")
                    template(v-if="typeof data !== 'object'")
                      v-list-tile-content(v-text="data.item")
                    template(v-else)
                      v-list-tile-content
                        v-list-tile-title.mr-1 {{data.item.alias}} - {{data.item.position}} ({{ data.item.business_unit.bu_name }})
                        p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}
                        //- v-list-tile-sub-title(v-html="data.item.title")

                small(style="color: #F08703;" ) *CC can only view memo, cannot approve memo.

                v-autocomplete(
                  :search-input.sync='searchCrossCC',
                  style="padding: 0; margin:.5",
                  label="Cross CC",
                  id="imCrossCC",
                  v-model="tembusan",
                  :items="getCrossCCData",
                  chips,
                  color="blue-grey lighten-2",
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data",
                  multiple,
                  :append-icon="'close'"
                  @click:append="handleClearEvent(4)"
                  hide-no-data='',
                  @change="removeCc()",
                  hint="Enter at least 3 letters to find out the search results.",
                  return-object=true
                )
                  template(v-slot:selection="data")
                    v-chip.chip--select-multi(
                      :selected="data.selected",
                      close,
                      @click:close="removeCc(data.item)"
                    ) {{ data.item.alias }}
                  template(v-slot:item="data")
                    template(v-if="typeof data !== 'object'")
                      v-list-tile-content(v-text="data.item")
                    template(v-else)
                      v-list-tile-content
                        v-list-tile-title.mr-1 {{data.item.alias}} - {{data.item.position}} ({{ data.item.business_unit.bu_name }})
                        p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}
                        //- v-list-tile-sub-title(v-html="data.item.title")
                v-flex.autocomplete-result.d-flex.flex-row.align-center.mt-3
                  v-checkbox.mr-2(
                    id="imCBHideTTL",
                    v-model="disabledHidetitle",
                    label="Hide Title",
                    :disabled="useAlias"
                  )
                  v-checkbox(id="imCBUseAls", v-model="useAlias" label="Use Alias Name")
                  v-checkbox(id="imCBShowLogo", style='margin-left:1rem' v-model="useLogo" label="Show Company Logo")

                p(style="color: #F08703; font-size: 12px" class="mb-0" v-if="use_setting_max_approver && max_total_approver !== 0") *Each memo may have a maximum of ({{max_total_approver}}) approvers assigned within your Business Unit. Kindly ensure that the approver list does not exceed this limit.
              div(style="padding:0 1rem; flex:1")
                .badge-approval.d-flex.mt-0() 
                  .mr-3
                    img(src="../assets/icon/ic_tips.svg")
                  .align-self-center
                    i Tips: Drag and drop the approver by holding down the left mouse and dragging them. (Approval sequence follow when user input the approver)

                template
                  .mb-5.mt-5
                    p.title.mb-1 Approver
                    ol.autocomplete-results(v-show="approver")
                      draggable.list-group(
                        :list="approver",
                        :disabled="!enabled",
                        ghost-class="ghost",
                        @start="dragging = true",
                        @end="dragging = false"
                      )
                        li.autocomplete-result(
                          v-for="(requestor, i) in approver",
                          :key="requestor.id"
                        )
                          v-chip.list-group-item.ma-1( @click:close="removeApp(requestor)",x-large ,close,label) 
                            div
                              p(style="margin:0; font-size:14px !important") {{ requestor.alias }}  {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                              p(style='margin:0; font-size: 12px; color: gray;') {{ requestor.email }}
                              p(v-show="requestor.is_active == false" style="margin:0; color: #FF5252; font-size:12px") Approver is not active
                template
                  .mb-5.mt-5
                  p.title.mb-1 CC
                  ol.autocomplete-results(v-show="tembusan")
                    li.autocomplete-result(
                      v-for="(requestor, i) in tembusan",
                      key="i"
                    )
                      v-chip.ma-1( label ,x-large ,close @click:close="removeCc(requestor)") 
                        div
                          p(style="margin:0; font-size:14px !important") {{ requestor.alias }}  {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                          p(style='margin:0; font-size: 12px; color: gray;') {{ requestor.email }}
                          p(v-show="requestor.is_active == false" style="margin:0; color: #FF5252; font-size:12px") Account is not active
                      //- v-chip.ma-1(
                      //-   v-if="showApprover",
                      //-   @click:close="removeCc(requestor)",
                      //-   close,
                      //-   label
                      //- ) {{ requestor.alias }} {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                      //- v-chip.ma-1(v-else, label) {{ requestor.alias }} {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
          v-btn(id="imPage3Cancel", style="background-color: #f5f5f5;margin-left: 1.5rem" depressed, large, text="" @click="$router.push('/my-request')") Cancel
          v-btn(id="imPage3Back", style="margin-left: 0.5rem" dark, color="blue-grey", depressed, large, @click="e1 = 2") Back
          v-btn.ml-2(
            id="imPage3btnDraft",
            color="info",
            depressed,
            large,
            :disabled="approver.length == 0 || isLoading",
            :loading="isLoading"
            @click="submitMemo(1)"
          )
            v-icon insert_drive_file
            | &nbsp; Save as Draft
          v-btn(
            id="imPage3btnSubmit",
            style="margin: 0.5rem" 
            depressed,
            large,
            color="success",
            :disabled="approver.length == 0 || isLoading",
            :loading="isLoading"
            @click="submitMemo(2)"
          ) 
            v-icon send
            | &nbsp; Submit Request
          
</template>

<script>
import axios from "axios";
//- import * as masterBank from "../data/bank.json";
import {Money} from 'v-money'
import draggable from "vuedraggable";
export default {
  components: {
    components: {Money},
    draggable,
  },
  data() {
    return {
      prevSelectedBUID: null,
      vNullAncDtl: false,
      useLogo: true,
      pickerStyle: false,
      dialogChangeCurency: false,
      dialogConfirmDelete: false,
      tempDeleteItem: null,
      money: {
        decimal: ',',
        thousands: '.',
        precision: 0,
        masked: false,
        suffix: ' IDR',
      },
      moneyUSD: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: false,
        suffix: ' USD',
      },
      moneyAdd: {
        decimal: ',',
        thousands: '.',
        precision: 0,
        masked: false,
      },
      moneyUSDAdd: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: false,
      },
      isLoading: false,
      btnLoader: false,
      masterBank: [],
      searchCrossCC: '',
      searchCrossBU: '',
      e1: 1,
      alertMessage:"",
      alert: false,
      enabled: this.$route.fullPath.includes("create-announcement-memo") ? true : false,
      dragging: false,
      approver:[],
      tembusan:[],
      myBuMember:[],
      crosBuMember:[],
      listCrossCC:[],
      totalPayment:0,
      myBuList: [],
      imAnchSelectedBU: '',
      imAnchSubject:'',
      imAnchFrom:'',
      imAnchTo:'',
      addItemPrice:null,
      select: "",
      items: ["BU01", "BU02", "BU03"],
      search: "",
      selectedCurrency: {value:"IDR", text: "IDR",},
      currencyBox: [
        {
          text: "IDR",
          value: "IDR",
        },
        {
          text: "USD",
          value: "USD",
        },
      ],
      headerProps: {
        class: 'custom-header',
      },
      headers: [
        {
          text: "Items",
          value: "name",
          sortable: false,
          width: '50%'
        },
        {
          text: "",
          value: "amount",
          sortable: false,
          width: '40%'
        },
        { text: "", value: "actions", sortable: false, width: "10%" },
      ],
      paymentItems: [],
      editedIndex: -1,
      editedItem: {
        id: 0,
        name: "",
        amount: 0,
      },
      defaultItem: {
        id: 0,
        name: "New Item",
        amount: 0,
      },
      useAlias: true,
      hideTitle: [],
      disabledHidetitle: false,
      pickerStyle: false,
      max_total_approver: 0,
      use_setting_max_approver: true,
    };
  },

  computed: {
    form1Validation() {
      if (this.imAnchSelectedBU && this.imAnchSubject && this.imAnchFrom && this.imAnchTo ) return false
      return true
    },
    form2Validation() {
      if (myEditor4.getData().trim() && myEditor1.getData().trim() != "<p>&nbsp;</p>") return false
      return true
    },
    getCCData() {
      let result = []
      for (let i in this.myBuMember)  {
        this.myBuMember[i].isCros = false
        result.push(this.myBuMember[i])
      }
      return result
    },
    getCrossCCData() {
      let result = []
      for (let i in this.listCrossCC)  {
        this.listCrossCC[i].isCros = true
        result.push(this.listCrossCC[i])
      }
      return result
    },
  },
  methods: {
    trigerChange(e) {
      this.approver = []
      this.myBuMember = []
      this.crosBuMember = []
      this.tembusan = []
      this.listCrossCC = []
      if (this.use_setting_max_approver) {
        let token = localStorage.getItem("token");
        axios
          .get(
            process.env.VUE_APP_API +
              `/business-unit/detail/${this.imAnchSelectedBU.buid}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          )
          .then((res) => {
            this.max_total_approver = res.data.max_approver ? res.data.max_approver : 0;
          })
          .catch((err) => {
            this.$toasted.error(err, { icon: "error" });
          })
      }
    },
    handleClearEvent(al) {
      let data1 = []
      let data2 = []
      let result = []
      if (al == 1) {
        data1 = this.approver
        data2 = this.myBuMember
      } else if (al == 2) {
        data1 = this.approver
        data2 = this.crosBuMember
      } else if (al == 3) {
        data1 = this.tembusan
        data2 = this.getCCData
      } else if (al == 4) {
        data1 = this.tembusan
        data2 = this.getCrossCCData
      }

      for ( let i in data1) {
        let isFound = false
        for (let j in data2) {
          if (data1[i].id == data2[j].id) isFound = true
        }
        if (!isFound) result.push(data1[i])
      }

      if (al == 1 || al == 2) this.approver = result
      else this.tembusan = result
    },
    disablePaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData('text/plain');
      if (/^[^a-zA-Z]*$/.test(pastedData)) return
      event.preventDefault();
    },
    handleChangeCurrency() {
      this.addItemName = ""
      this.addItemPrice = 0
      if (this.paymentItems.length > 0 ) this.dialogChangeCurency = true;
      else return
      if (this.selectedCurrency.value == "IDR") this.selectedCurrency = {value:"USD", text: "USD"}
      else this.selectedCurrency = {value:"IDR", text: "IDR"}
    },
    numberOnly(evt) {
      evt = (evt) ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      
      if (!/^[0-9]+$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    sumField(key) {
        // sum data in give key (property)
        const res = this.paymentItems.reduce((a, b) => +a + +(b[key] || 0), 0)
        this.totalPayment = res
        return res
    },
    removeCc(item) {
      // const index = this.users.indexOf(item)
      // if (index >= 0) this.users.splice(index, 1)
      let tembusans = this.tembusan.indexOf(item);
      if (this.edit) {
        for (const key in this.tembusan) {
          if (this.tembusan[key].id == item.id) {
            tembusans = key;
            break;
          }
        }
      }
      if (tembusans >= 0) this.tembusan.splice(tembusans, 1);
    },
    removeApp(item) {
      let approvers = this.approver.indexOf(item);
      if (this.edit) {
        for (const key in this.approver) {
          if (this.approver[key].id == item.id) {
            approvers = key;
            break;
          }
        }
      }
      if (approvers >= 0) this.approver.splice(approvers, 1);
    },
    countTotal() {
      let ttl = 0
      for (let i in this.paymentItems) ttl+= +this.paymentItems[i].amount
      this.totalPayment = ttl
    },
    editItem(item) {
      this.editedIndex = this.paymentItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
    },
    deleteItem() {
      const index = this.paymentItems.indexOf(this.tempDeleteItem);
      this.paymentItems.splice(index, 1);
      this.countTotal()
      this.tempDeleteItem = null
    },
    close() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    addNew() {
      if (!this.addItemName || !this.addItemPrice) return
      let id = 1
      for ( let i in this.paymentItems) {
        this.paymentItems[i].id = id
        id++
      }
      const addObj = Object.assign(
        {},
        {
          name: this.addItemName,
          amount: this.addItemPrice,
          currency: this.selectedCurrency.value,
        }
      );
      addObj.id = this.paymentItems.length + 1;
      this.paymentItems.unshift(addObj);
      this.editItem(addObj);
      this.save();
      this.addItemPrice = 0
      this.addItemName = ''
    },
    save() {
      if (!this.editedItem.amount || !this.editedItem.name) return
      if (this.editedIndex > -1) {
        Object.assign(this.paymentItems[this.editedIndex], this.editedItem);
      }
      this.countTotal()
      this.close();
    },
    changeCurency() {
      //- for(let i in this.paymentItems)this.paymentItems[i].currency = this.selectedCurrency.value
      this.paymentItems = []
    },
    async getMyActiveBU() {
      try{
        const token = localStorage.getItem("token");
        const userId = this.$store.state.dataUsers.user
        if (userId) {
          const reqDataBU = await axios.get(`${process.env.VUE_APP_API}/users/active/bu/${userId._id}`, { headers: { Authorization: `Bearer ${token}` }})
          const listBU = reqDataBU.data.data
          for (let i in listBU) {
            if (listBU.length == 1) listBU[i].label = `${listBU[i].business_unit.bu_name}`
            else listBU[i].label = `${listBU[i].business_unit.bu_name} as ${listBU[i].position ? listBU[i].position : ''}`
            listBU[i].value = {
              buid: listBU[i].business_unit.id,
              userid: listBU[i].id
            }

          }
          this.myBuList = listBU
        }
      } catch(e) {
        console.log(e)
      }
    },
    async getCrossBUMember() {
      try{
        const token = localStorage.getItem("token");
        this.crosBuMember = []
        const reqDataCrossBUMember = await axios.get(`${process.env.VUE_APP_API}/users/busines-unit/${this.imAnchSelectedBU.buid}`, { headers: { Authorization: `Bearer ${token}` }})
        const dataCrossBUMember = reqDataCrossBUMember.data.data
        for(let i in dataCrossBUMember) if (dataCrossBUMember[i].email != this.$store.state.dataUsers.user.email) for (let j in this.approver) if (this.approver[i].email == dataCrossBUMember[i].email) this.crosBuMember.push(dataCrossBUMember[i])
      } catch(e) {
        console.log(e)
      }
    },
    async getMyBUMember() {
      if (myEditor4.getData().trim() && myEditor4.getData().trim() != "<p>&nbsp;</p>") {
        this.e1 = 3
        try{
          const token = localStorage.getItem("token");
          const reqDataMyBUMember = await axios.get(`${process.env.VUE_APP_API}/users/bu/list/${this.imAnchSelectedBU.buid}`, { headers: { Authorization: `Bearer ${token}` }})
          const dataMyBUMember = reqDataMyBUMember.data.data
          this.myBuMember = dataMyBUMember
        } catch(e) {
          console.log(e)
        }
      } else {
        this.vNullAncDtl = true 
        setTimeout(()=> {
          this.vNullAncDtl = false 
        }, 2000)
      }
    },
    async submitMemo(act) {
      this.isLoading = true;
      try {
        const reqCreatorData = await axios.get(`${process.env.VUE_APP_API}/memo/creator/${this.imAnchSelectedBU.userid}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`
          }
        });
        const creator_data = reqCreatorData.data.data
        creator_data.name = this.$store.state.dataUsers.user.full_name

        const chosenBUDetail = await axios.get(`${process.env.VUE_APP_API}/business-unit/detail/${this.imAnchSelectedBU.buid}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`
          }
        });
        chosenBUDetail.data.id = chosenBUDetail.data._id;
        delete chosenBUDetail.data._id;

        //- CONTAIN INTERNAL AND CROSS BU APPV
        const approvers = [];


        if (this.tembusan) {
          for (const item of this.tembusan) { 
            if (!item.is_active) {
              this.errorActiveUserMsg = statusBeforeSubmit == 3 ? "Sorry, there is inactive account. Please contact admin or withdraw memo.": "Sorry, there is inactive account. Please close or change new account."
              this.dialogInactiveApprover = true
              this.isLoading = false;
              this.status = statusBeforeSubmit;
              return
            }
          }
        }


        for (const item of this.approver) {
          if (!item.is_active) {
            this.errorActiveUserMsg = statusBeforeSubmit == 3 ? "Sorry, there is inactive account. Please contact admin or withdraw memo.": "Sorry, there is inactive account. Please close or change new account."
            this.dialogInactiveApprover = true
            this.isLoading = false;
            this.status = statusBeforeSubmit;
            return
          }
          if (typeof item.comment === "undefined") {
            this.$set(item, "comment", null);
          }

          if (this.useAlias) {
            this.$set(item, "name", item.name);
          }

          this.$set(item, "postAs", "approver");

          approvers.push(item);
        }
        

        let newApp = approvers
        if (act == 2) newApp[0].status = 9;

        let formData = new FormData();
        formData.append("userId", this.$store.state.dataUsers.user._id);
        formData.append("user", JSON.stringify(creator_data));
        formData.append("imType", 7);
        formData.append("imStatus", act);
        formData.append("imOrganization", JSON.stringify(chosenBUDetail.data));
        formData.append("imTargetDate", new Date().toISOString().substr(0, 10));
        formData.append("imUseAlias", this.useAlias ? true : false);
        formData.append("imHideTitle", this.disabledHidetitle ? true : false);
        formData.append("imApprover", JSON.stringify(newApp));
        formData.append("imCC", JSON.stringify(this.tembusan));
        formData.append("imGroup", "nongroup");
        formData.append("imPerihal", this.imAnchSubject.replaceAll(`"`, `'`).replace(/<meta charset="utf-8">/g, '').replace(/dir="ltr"/g,''));
        formData.append("imAnchFrom", this.imAnchFrom);
        formData.append("imAnchTo", this.imAnchTo);
        formData.append("imUseLogo", this.useLogo);
        formData.append("imAnchDetail", myEditor4.getData());

        const configSubmitMemoReq = {
          method: "post",
          url: process.env.VUE_APP_API_OLD + `/api/requests`,
          headers: { "Content-Type": "multipart/form-data" },
          data: formData,
        };

        const submitMemoReq = await axios(configSubmitMemoReq)

        if (submitMemoReq.status == 200) {
          
          this.isLoading = false;
            act == 1 ? 
            this.$toasted.info( "Memo has been successfully saved to draft",{ icon: "save"})
            : 
            this.$toasted.success("Success, the memo was successfully generated and sent to the approver.",{ icon: "check_circle"})
            this.$router.push("/my-request");
        }

      } catch(e) {
        console.log(e)
      }
    },
    setUseAlias() {
      if ( this.useAlias ) {
        this.disabledHidetitle = true
      }
    }
  },

  watch: {
    disabledHidetitle(val) {
      if (val != false || val != 0) {
        for (const key in this.bod) {
          this.hideTitle.push(this.bod[key].id);
        }
      } else {
        this.hideTitle = [];
      }
    },

    useAlias(val) {
      if (val != false || val != 0) {
        this.disabledHidetitle = true;
      } else if (this.disabledHidetitle == true && val == true) {
        this.disabledHidetitle = false;
        this.hideTitle = [];
      } else {
        this.hideTitle = [];
      }
    },
    async searchCrossCC(val) {
      try {
        if (val && val.length >= 3 && val.trim().length) {
        const token = localStorage.getItem("token");
        const {data} = await axios.get(`${process.env.VUE_APP_API}/users/busines-unit/${this.imAnchSelectedBU.buid}?key=${val}`,{
          headers: { Authorization: `Bearer ${token}` },
        })
        const res = data.data
        //- if (res.length != 0 ) this.listCrossCC = []
        for (let i in res ) if (res[i].is_active && res[i].name != this.$store.state.dataUsers.user.full_name) this.listCrossCC.push(res[i])
        }
      } catch(e) {
        if (e.response.status == 401 || e.response.status == 403) {
          this.$store.dispatch("logout");
          return this.$router.push("/");
            }
      } finally{
      }
    },
    async searchCrossBU(val) {
      try {
        if (val && val.length >= 3 && val.trim().length) {
        //- this.isLoading = true;
        const token = localStorage.getItem("token");
        const {data} = await axios.get(`${process.env.VUE_APP_API}/users/busines-unit/${this.imAnchSelectedBU.buid}?key=${val}`,{
          headers: { Authorization: `Bearer ${token}` },
        })
        const res = data.data
        //- if (res.length != 0 ) this.crosBuMember = []
        for (let i in res ) if (res[i].is_active && res[i].name != this.$store.state.dataUsers.user.full_name) this.crosBuMember.push(res[i])
        }
      } catch(e) {
        if (e.response.status == 401 || e.response.status == 403) {
          this.$store.dispatch("logout");
          return this.$router.push("/");
            }
      } finally{
        //- this.isLoading = false
      }
    },
    approver() {
      if (this.approver.length <= 0) {
        this.alert = false;
      }
      if (this.approver.length > 0) {
        let approver = this.approver[this.approver.length - 1];
        let isBreak = false;

        if (this.use_setting_max_approver && this.max_total_approver !== 0 && this.approver.length > this.max_total_approver) {
          this.alertMessage =
            `It reaches the maximum number (${this.max_total_approver}) of approver allowed in your BU!`;
          this.alert = true;
          this.approver.pop();
        } else {
          for (const iterator of this.tembusan) {
            if (isBreak) break;
            if (approver.id == iterator.id) {
              // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Approver (Budget), silakan pilih salah satu!');
              this.alertMessage =
                "The user you selected has been selected in the previous input field, please choose one!";
              isBreak = true;
              this.alert = true;
              this.approver.pop();
              break;
            }
          }
        }
      }
    },
    tembusan() {
      if (this.tembusan.length > 0) {
        let tembusan = this.tembusan[this.tembusan.length - 1];
        let isBreak = false;

        for (const iterator of this.approver) {
          if (isBreak) break;
          if (tembusan.id == iterator.id) {
            // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Approver (beside BOD), silakan pilih salah satu!');
            isBreak = true;
            this.alertMessage = "The user you selected has been selected in the previous input field, please choose one!";
            this.alert = true;
            this.tembusan.pop();
            break;
          }
        }
      }
    },
  },

  created() {
    setTimeout(()=> {
      this.getMyActiveBU();
    }, 1000)

    let memoScript = document.createElement('script')
    memoScript.setAttribute('src', '/js/memo.js')
    document.body.appendChild(memoScript)
  },

  mounted: async function () {
    this.setUseAlias();
    const listBankResp = await axios.get(`${process.env.VUE_APP_API_OLD}/api/list_bank`)
    this.masterBank = listBankResp.data || []
  }
};
</script>
<style >
.IMP-group-form {
  display: flex;
}

.IMP-title-form {
  margin: auto;
}

#dtbl th {
  background-color: #f0f0f0 !important; /* Ganti dengan warna yang diinginkan */
  color: #333; /* Ganti dengan warna teks yang diinginkan */
}
#dtbl th span {
  font-weight: bold;
  font-size: 18px;
}

#ThisToolbar .v-toolbar__content {
  padding: 0px !important;
  box-shadow: none !important;
}
td .v-money{
  text-align: right;
  width:90%;
}
th .v-money{
  text-align: right;
  width:90%;
}
</style>
